import PropTypes from 'prop-types';
import React, { useReducer } from 'react';
import { initialState, reducer } from './Reducer';

export const SnackbarContext = React.createContext({
  state: initialState,
  dispatch: () => null,
});

export const SnackbarProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <SnackbarContext.Provider value={[state, dispatch]}>{children}</SnackbarContext.Provider>;
};

// proptypes
SnackbarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
